import { IQuantityPerUnit } from '@pia/pia.shared';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterNonStringPackingUnits',
  pure: true,
})
export class ArticleFilterNonStringPackingUnitsPipe implements PipeTransform {
  transform(packagingUnits: IQuantityPerUnit[]): IQuantityPerUnit[] {
    return packagingUnits.filter(packagingUnit => typeof packagingUnit.pcn === 'string');
  }
}
